import * as React from "react";

function Card({ className, style, ...props }) {
  return (
    <div
      data-slot="card"
      style={{
        backgroundColor: "#fff", // Replace with your desired background color
        color: "#000", // Replace with your desired text color
        display: "flex",
        flexDirection: "column",
        borderRadius: "0.75rem",
        border: "1px solid #e5e7eb", // Replace with your desired border color
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        ...style,
      }}
      className={className}
      {...props}
    />
  );
}

function CardHeader({ className, style, ...props }) {
  return (
    <div
      data-slot="card-header"
      style={{
        display: "grid",
        gridAutoRows: "min-content",
        gridTemplateRows: "auto auto",
        alignItems: "start",
        gap: "0.375rem",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        ...style,
      }}
      className={className}
      {...props}
    />
  );
}

function CardTitle({ className, style, ...props }) {
  return (
    <div
      data-slot="card-title"
      style={{
        lineHeight: "1",
        fontWeight: "600",
        ...style,
      }}
      className={className}
      {...props}
    />
  );
}

function CardDescription({ className, style, ...props }) {
  return (
    <div
      data-slot="card-description"
      style={{
        color: "#6b7280", // Replace with your desired muted text color
        fontSize: "0.875rem",
        ...style,
      }}
      className={className}
      {...props}
    />
  );
}

function CardAction({ className, style, ...props }) {
  return (
    <div
      data-slot="card-action"
      style={{
        gridColumnStart: 2,
        gridRowStart: 1,
        gridRowEnd: 3,
        alignSelf: "start",
        justifySelf: "end",
        ...style,
      }}
      className={className}
      {...props}
    />
  );
}

function CardContent({ className, style, ...props }) {
  return (
    <div
      data-slot="card-content"
      style={{
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        ...style,
      }}
      className={className}
      {...props}
    />
  );
}

function CardFooter({ className, style, ...props }) {
  return (
    <div
      data-slot="card-footer"
      style={{
        display: "flex",
        alignItems: "center",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        ...style,
      }}
      className={className}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
};
